import { PillStateType } from '@kubit/web-ui-components/pill/types';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { KubitPillSizeType, KubitPillVariantType, TextVariantType } from '../../variants';
import { commonStyles, labelDisabledCommonStyles, labelDisabledSelectedCommonStyles, labelSelectedCommonStyles, } from '../commonStyles';
const buildCommonProps = (FOUNDATIONS, FONT) => ({
    ...commonStyles(FOUNDATIONS, FONT),
    rootContainer: {
        display: 'flex',
        flex_direction: 'column',
        align_items: 'center',
        gap: FOUNDATIONS.spacing_100,
    },
    kubitPill: {
        variant: KubitPillVariantType.ROUNDED,
        size: KubitPillSizeType.DEFAULT,
    },
    externalLabel: {
        font_variant: TextVariantType.FONT_PARAGRAPH_500,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_neutral_font_50,
    },
});
export const getRoundedStyles = (FOUNDATIONS, FONT) => {
    const commonProps = buildCommonProps(FOUNDATIONS, FONT);
    return {
        [PillStateType.DEFAULT]: {
            ...commonProps,
        },
        [PillStateType.SELECTED]: {
            ...commonProps,
            label: {
                ...labelSelectedCommonStyles(FOUNDATIONS, FONT),
            },
            externalLabel: {
                ...commonProps.externalLabel,
                font_variant: TextVariantType.FONT_PARAGRAPH_550,
                font_weight: FONT_WEIGHT.font_weight_600,
                color: FOUNDATIONS.color_neutral_font_50,
            },
        },
        [PillStateType.DISABLED]: {
            ...commonProps,
            label: {
                ...labelDisabledCommonStyles(FOUNDATIONS, FONT),
            },
            externalLabel: {
                ...commonProps.externalLabel,
                color: FOUNDATIONS.color_accent_disabled_font_100,
            },
        },
        [PillStateType.DISABLED_SELECTED]: {
            ...commonProps,
            label: {
                ...labelDisabledSelectedCommonStyles(FOUNDATIONS, FONT),
            },
            externalLabel: {
                ...commonProps.externalLabel,
                font_variant: TextVariantType.FONT_PARAGRAPH_550,
                font_weight: FONT_WEIGHT.font_weight_600,
                color: FOUNDATIONS.color_accent_disabled_font_50,
            },
        },
    };
};
//# sourceMappingURL=rounded.js.map